<div
  appElevation
  #switchContainer
  [class]="{
    'fade-left': leftFade,
    'fade-right': rightFade,
    'switch-container': enableScrollFade(),
    semibold: fontSemibold()
  }"
  (scroll)="enableScrollFade() && onHorizontalScroll()"
  (wheel)="enableScrollFade() && onWheelScroll($event)"
  [elevation]="enableScrollFade() && elevation()"
>
  <div
    appElevation
    [elevation]="!enableScrollFade() && elevation()"
    class="switch"
    [class.switch--disabled]="disabled"
    [class]="'switch--size-' + size()"
  >
    @for (
      item of config();
      track item[itemValueKey()];
      let i = $index;
      let isLast = $last
    ) {
      <div
        [class]="{
          'd-flex align-items-center': true,
          switch__container: !enableDivider()
        }"
      >
        @if (!item.invisible) {
          <div
            class="switch__item"
            [class]="{
              'switch__item--active': selectedItem() === item[itemValueKey()],
              'switch__item--disabled': item.disabled
            }"
            [imTooltip]="(item.disabled ? item.tooltip : null) | translate"
            (click)="selectItem(item)"
          >
            @if (item.label) {
              <span> {{ item.label | translate }} </span>
            }
            @if (item.amount !== undefined) {
              <app-badge
                [class.ms-2]="item.label"
                [color]="
                  item[itemValueKey()] === selectedItem()
                    ? BadgeColorEnum.NEUTRAL_LIGHT
                    : BadgeColorEnum.NEUTRAL_LIGHT_DARK
                "
                [fontBold]="fontSemibold()"
              >
                @if (showLoadingIndicatorForCount()) {
                  <div class="skeleton"></div>
                } @else {
                  {{ item.amount }}
                }
              </app-badge>
            }
          </div>
          @if (!isLast && enableDivider()) {
            <div class="switch__divider"></div>
          }
        }
      </div>
    }
  </div>
</div>
